import type { TestResultCreate } from "@louise/medical-history/basic-info/types";

const NON_FERTILITY_IMAGING_CATEGORIES = new Set([
  "mammogram",
  "breast_ultrasound",
  "breast_tomosynthesis",
  "breast_mri",
]);

export type FertilityTestingResultLike = {
  type?: TestResultCreate["type"] | "semenFluidAnalysis" | null;
  imagingTestCategory?: string | null;
  clinicalTestCategory?: string | null;
};

/**
 * Test results are shared by the Medical History and Medical Reports flows.
 * Keep general breast imaging and other non-fertility records out of this
 * flow's selection and delete operations.
 */
export function isFertilityTestingResult(
  result: FertilityTestingResultLike,
): boolean {
  if (
    result.type === "imaging" &&
    result.imagingTestCategory &&
    NON_FERTILITY_IMAGING_CATEGORIES.has(result.imagingTestCategory)
  ) {
    return false;
  }

  if (result.type === "clinical") {
    return result.clinicalTestCategory === "other";
  }

  return (
    result.type === "urine" ||
    result.type === "blood" ||
    result.type === "genetics" ||
    result.type === "imaging" ||
    result.type === "sampling" ||
    result.type === "semen_fluid"
  );
}
